import { IOrderObject } from '@/types/orderDetail'
import { getDeductCount } from '@/api/Allservices'

interface IRatioMap {
  [key: string]: number
}

// 获取下载文件的页数
export const getPageCount = async (row: IOrderObject, ratioMap: IRatioMap) => {
  const serviceCount = row.service_content

  switch (serviceCount) {
    // case 4:
    //   return row?.material?.oss_img_files?.[0].page_count || 0
    case 16:
      let wordCount = row?.material?.oss_word_files?.[0].page_count || 0
      wordCount = (wordCount * ratioMap.word2fbd).toFixed(1)
      return parseFloat(wordCount)
    case 25:
      const pptCount = await getDeductCount({ ticket_id: row.ticket_id, point_type: 'ppt_seewo' })
      return parseFloat(pptCount.point_count)
    case 24:
      let rowCount = row?.material?.oss_pdf_files?.[0].page_count || 0
      // 交付物：word
      if (row.delivery == 1) {
        rowCount = (rowCount * ratioMap.pdf2word).toFixed(1)
      }
      // 交付物：fbd
      else if (row.delivery == 4) {
        rowCount = (rowCount * ratioMap.pdf2fbd).toFixed(1)
      }
      // 交付物：word + fbd
      else if (row.delivery == 21) {
        rowCount = (rowCount * ratioMap.pdf2word_fbd).toFixed(1)
      }
      return parseFloat(rowCount)
  }

  return 0
}
